import { createApi } from '@reduxjs/toolkit/dist/query/react';

import { getBaseQuery, TransformedResponseWithNotification } from '../generic';
import * as endpoints from '../endpoints';
import { REDUX_CACHE, HTTP_METHOD, USERS } from '../constants';
import { usersApi } from './usersApi';

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  tagTypes: [],
  baseQuery: getBaseQuery(),
  // global configuration for the api
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    subscribeToPlanApi: builder.mutation<
      { clientSecret: string },
      { planId: string }
    >({
      query({ planId }) {
        return {
          url: `${endpoints.Payments.ROOT}${endpoints.Payments.PLAN_SUBSCRIPTION.replace('${0}', planId)}`,
          method: HTTP_METHOD.POST,
        };
      },
      async onQueryStarted(v, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(usersApi.util.invalidateTags([USERS.ME]));
      },
      // invalidatesTags: (result, error, params) => {
      // 	if (error) {
      // 		return [REDUX_CACHE.ABORT_INVALIDATION];
      // 	}
      // },
      // ...TransformedResponseWithNotification("Subscription")
    }),
    setupIntentApi: builder.mutation<{ clientSecret: string }, void>({
      query() {
        return {
          url: `${endpoints.Payments.ROOT}${endpoints.Payments.SETUP_INTENT}`,
          method: HTTP_METHOD.POST,
        };
      },
      invalidatesTags: [],
      // invalidatesTags: (result, error, params) => {
      // 	if (error) {
      // 		return [REDUX_CACHE.ABORT_INVALIDATION];
      // 	}
      // },
    }),
    cancelPlanApi: builder.mutation<void, void>({
      query() {
        return {
          url: `${endpoints.Payments.ROOT}${endpoints.Payments.CURRENT_SUBSCRIPTION}`,
          method: HTTP_METHOD.DELETE,
        };
      },
      async onQueryStarted(v, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(usersApi.util.invalidateTags([USERS.ME]));
      },
      // invalidatesTags: (result, error, params) => {
      // 	if (error) {
      // 		return [REDUX_CACHE.ABORT_INVALIDATION];
      // 	}
      // },
      // ...TransformedResponseWithNotification("Subscription")
    }),
  }),
});

export const {
  useCancelPlanApiMutation: useCancelPlan,
  useSetupIntentApiMutation: useSetupIntent,
  useSubscribeToPlanApiMutation: useSubscribeToPlan,
} = paymentApi;
